"use client";

import type { ReactNode } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

/**
 * A centred spinner with a line of text under it, replacing the `.loading`
 * rule — identical in admin.css and liff.css — whose spinner was a rotating
 * border drawn in a `::before`.
 *
 * At the package root, not under one surface, because both use it: admin while
 * a page's data loads, liff while a step reloads availability.
 *
 * The 200px floor is deliberate. On liff these appear INSIDE a step panel that
 * is already open, and without it the panel collapsed to the height of one line
 * of text and the page jumped every time availability reloaded.
 */
export function Loading({ children }: { children?: ReactNode }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 200,
        gap: 1.5,
      }}
    >
      <CircularProgress size={32} />
      <Typography color="text.secondary">{children}</Typography>
    </Box>
  );
}
